import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../../contexts/UserContext';
import withRecaptcha from '../../../HOC/withRecaptcha';
import './ComunasTarifas.css'

// Utility function for API calls
const apiCall = async (url, method = 'GET', body = null, token = null) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
  const config = {
    method,
    headers,
    ...(body && { body: JSON.stringify(body) })
  };
  const response = await fetch(url, config);
  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Error de autenticación');
    } else {
      throw new Error('API call failed');
    }
  }
  return response.json();
};

const CrearEmpresa = ({ token, onSubmitWithRecaptcha  }) => {
  const [companyName, setCompanyName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCompanyNameChange = (e) => {
    setCompanyName(e.target.value);
  };

  const handleCreateCompany = async (e) => {
    e.preventDefault();
    if (!companyName) {
      alert('Por favor complete todos los campos.');
      return;
    }

    const submitForm = async (event, recaptchaToken) => {
      setIsSubmitting(true);
      try {
        const result = await apiCall(
          `${process.env.REACT_APP_API_URL}/companies/create`, 
          'POST', 
          {
            companyName,
            recaptchaToken
          }, 
          token
        );
        alert(result.message);
        setIsSubmitting(false);
        window.location.reload();
      } catch (error) {
        console.error('Error al crear empresa:', error);
        alert(error.message);
        setIsSubmitting(false);
      }
    };

    await onSubmitWithRecaptcha(e, submitForm);
  };

  return (
    <form className="comunas-tarifas-field-group" onSubmit={handleCreateCompany}>
      <h3>Crear Empresa</h3>
      <input type="text" className="comunas-tarifas-field" value={companyName} onChange={handleCompanyNameChange} placeholder="Nombre de la empresa"/>
      <button type="submit" className="comunas-tarifas-submit-button" disabled={isSubmitting}>Crear Empresa</button>
    </form>
  );
};

//Actualizar empresa
const ActualizarEmpresa = ({ token, onSubmitWithRecaptcha  }) => {
  const [selectedCompany, setSelectedCompany] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/companies/all`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error('Failed to fetch companies');
        }
        const data = await response.json();
        setCompanies(data);
      } catch (error) {
        console.error('Error fetching companies:', error);
      }
    };

    fetchCompanies();
  }, [token]);

  const handleCompanyChange = (e) => {
    setSelectedCompany(e.target.value);
    const selectedCompanyData = companies.find((company) => company.company_id === parseInt(e.target.value));
    if (selectedCompanyData) {
      setCompanyName(selectedCompanyData.company_name);
    } else {
      setCompanyName('');
    }
  };

  const handleCompanyNameChange = (e) => {
    setCompanyName(e.target.value);
  };

  const handleUpdateCompany = async (e) => {
    e.preventDefault();
    if (!selectedCompany || !companyName) {
      alert('Por favor complete todos los campos.');
      return;
    }

    const submitForm = async (event, recaptchaToken) => {
      setIsSubmitting(true);
      try {
        const result = await apiCall(
          `${process.env.REACT_APP_API_URL}/companies/${selectedCompany}`, 
          'PUT', 
          {
            companyName,
            recaptchaToken
          }, 
          token
        );
        alert(result.message);
        setIsSubmitting(false);
        window.location.reload();
      } catch (error) {
        console.error('Error al actualizar empresa:', error);
        alert('Error al actualizar empresa');
        setIsSubmitting(false);
      }
    };

    await onSubmitWithRecaptcha(e, submitForm);
  };

  return (
    <form className="comunas-tarifas-field-group" onSubmit={handleUpdateCompany}>
      <h3>Actualizar Empresa</h3>
      <select className="comunas-tarifas-field" value={selectedCompany} onChange={handleCompanyChange}>
        <option value="">Seleccione una empresa</option>
        {companies.map((company) => (
          <option key={company.company_id} value={company.company_id}>
            {company.company_name}
          </option>
        ))}
      </select>
      <input type="text" className="comunas-tarifas-field" value={companyName} onChange={handleCompanyNameChange} placeholder="Nombre de la empresa"/>
      <button type="submit" className="comunas-tarifas-submit-button" disabled={isSubmitting}>Actualizar Empresa</button>
    </form>
  );
};

//Campiar prioridad empresa
const SwapCompanyPriority = ({ token, onPriorityChanged }) => {
  const [companyId1, setCompanyId1] = useState('');
  const [companyId2, setCompanyId2] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/companies/all`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error('Failed to fetch companies');
        }
        const data = await response.json();
        setCompanies(data);
      } catch (error) {
        console.error('Error fetching companies:', error);
      }
    };

    fetchCompanies();
  }, [token]);

  const handleCompanyId1Change = (e) => {
    setCompanyId1(e.target.value);
  };

  const handleCompanyId2Change = (e) => {
    setCompanyId2(e.target.value);
  };

  const handleSwapPriority = async (e) => {
    e.preventDefault();
    if (!companyId1 || !companyId2) {
      alert('Por favor complete todos los campos.');
      return;
    }
    setIsSubmitting(true);
    try {
      const result = await apiCall(`${process.env.REACT_APP_API_URL}/companies/swap-priority-levels`, 'POST', {
        companyId1,
        companyId2,
      }, token);
      alert(result.message);
      setIsSubmitting(false);
      onPriorityChanged(); // Llama a la función para recargar
    } catch (error) {
      console.error('Error al intercambiar prioridad de empresas:', error);
      alert('Error al intercambiar prioridad de empresas');
      setIsSubmitting(false);
    }
  };

  return (
    <form class="comunas-tarifas-field-group" onSubmit={handleSwapPriority}>
      <h3>Intercambiar prioridad de empresas</h3>
      <select className="comunas-tarifas-field" value={companyId1} onChange={handleCompanyId1Change}>
        <option value="">Seleccione una empresa</option>
        {[...companies] // Crear una copia del array para no mutar el original
          .sort((a, b) => a.priority_level - b.priority_level) // Ordenar por priority_level
          .map((company) => (
            <option key={company.company_id} value={company.company_id}>
              {company.company_name} (Prioridad: {company.priority_level})
            </option>
          ))}
      </select>
      <select className="comunas-tarifas-field" value={companyId2} onChange={handleCompanyId2Change}>
        <option value="">Seleccione otra empresa</option>
        {[...companies]
          .sort((a, b) => a.priority_level - b.priority_level)
          .map((company) => (
            <option key={company.company_id} value={company.company_id}>
              {company.company_name} (Prioridad: {company.priority_level})
            </option>
          ))}
      </select>
      <button type="submit" className="comunas-tarifas-submit-button" disabled={isSubmitting}>Intercambiar prioridad</button>
    </form>
  );
};


// Habilitar/Deshabilitar empresa
const ToggleCompanyStatus = ({ token, onStatusChanged }) => {
  const [selectedCompany, setSelectedCompany] = useState('');
  const [isActive, setIsActive] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const getCompanies = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/companies/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        setCompanies(data);
      } catch (error) {
        console.error('Error al obtener las empresas:', error);
      }
    };
    getCompanies();
  }, [token]);

  const handleCompanyChange = (e) => {
    setSelectedCompany(e.target.value);
  };

  const handleIsActiveChange = (e) => {
    setIsActive(e.target.value);
  };

  const handleToggleStatus = async (e) => {
    e.preventDefault();
    if (!selectedCompany || isActive === '') {
      alert('Por favor seleccione una empresa y especifique el estado.');
      return;
    }
    setIsSubmitting(true);
    try {
      const result = await apiCall(`${process.env.REACT_APP_API_URL}/companies/${selectedCompany}/toggle-status`, 'PATCH', {
        is_active: isActive === '1',
      }, token);
      alert(result.message);
      setIsSubmitting(false);
      onStatusChanged(); // Llama a la función para recargar
    } catch (error) {
      console.error('Error al habilitar/deshabilitar empresa:', error);
      alert('Error al habilitar/deshabilitar empresa');
      setIsSubmitting(false);
    }
  };
  
  return (
    <form class="comunas-tarifas-field-group" onSubmit={handleToggleStatus}>
      <h3>Habilitar/Deshabilitar empresa</h3>
      <select className="comunas-tarifas-field" value={selectedCompany} onChange={handleCompanyChange}>
        <option value="">Seleccione una empresa</option>
        {Array.isArray(companies) && companies.map((company) => (
          <option key={company.company_id} value={company.company_id}>
            {company.company_name} (Estado: {company.is_active === true ? 'Habilitada' : 'Deshabilitada'})
          </option>
        ))}
      </select>
      <select className="comunas-tarifas-field" value={isActive} onChange={handleIsActiveChange}>
        <option value="">Seleccione el estado</option>
        <option value="1">Habilitar</option>
        <option value="0">Deshabilitar</option>
      </select>
      <button type="submit" className="comunas-tarifas-submit-button" disabled={isSubmitting}>Habilitar/Deshabilitar</button>
    </form>
  );
};

// Envolver los componentes con withRecaptcha
const CrearEmpresaWithRecaptcha = withRecaptcha(CrearEmpresa, 'create_company');
const ActualizarEmpresaWithRecaptcha = withRecaptcha(ActualizarEmpresa, 'update_company');


// Main component
const Empresas = () => {
  const { token } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState('crear');
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  // Mover fetchData fuera del useEffect para que esté disponible en todo el componente
  const fetchData = async () => {
    if (!token) return;
    try {
      const companiesData = await apiCall(
        `${process.env.REACT_APP_API_URL}/companies`, 
        'GET', 
        null, 
        token
      );
      setCompanies(companiesData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [token]);

  const renderTabContent = () => {
    switch(activeTab) {
      case 'crear':
        return <CrearEmpresaWithRecaptcha 
          token={token} 
          onCompanyCreated={() => {
            // Recargar empresas después de crear
            fetchData();
          }} 
        />;
      case 'actualizar':
        return <ActualizarEmpresaWithRecaptcha 
          token={token} 
          companies={companies}
          initialCompany={selectedCompany} 
        />;
      case 'prioridad':
        return <SwapCompanyPriority 
          token={token} 
          onPriorityChanged={() => {
            fetchData();
          }} 
        />;
      case 'estado':
        return <ToggleCompanyStatus 
          token={token} 
          onStatusChanged={() => {
            fetchData();
          }} 
        />;
      default:
        return null;
    }
  };

  // Ordenar las empresas por priority_level de mayor a menor
  const sortedCompanies = [...companies].sort((a, b) => a.priority_level - b.priority_level);


  return (
    <div className="comunas-container">
      <h1 className="comunas-page-title">Gestión de Empresas</h1>
      
      <div className="comunas-tabs-container">
        {[
          { key: 'crear', label: 'Crear Empresa' },
          { key: 'actualizar', label: 'Actualizar Empresa' },
          { key: 'prioridad', label: 'Intercambiar Prioridad' },
          { key: 'estado', label: 'Cambiar Estado' }
        ].map(tab => (
          <button
            key={tab.key}
            className={`comunas-tab ${activeTab === tab.key ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="comunas-tab-content">
        <div className="content-wrapper">
          <div className="promotions-list-table-container">
            <h3 className="tarifas-section-title">Listado de Empresas</h3>
            <table className="promotions-list-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Prioridad</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {sortedCompanies.map((company) => (
                  <tr 
                    key={company.company_id}
                    className={selectedCompany?.company_id === company.company_id ? 'selected-row' : ''}
                  >
                    <td>{company.company_name}</td>
                    <td>{company.priority_level}</td>
                    <td>
                      {company.is_active ? 'Activa' : 'Inactiva'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="form-section">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};


export default Empresas;